import React, { Component } from 'react';
import { Col, Row } from 'antd';
import FlowSearch from '@comm/FlowSearch';
import './expenses.less';
import { connect } from 'react-redux';
import { setBackInfo } from '@store/modules/back_info';
import { bonus, queryBonusOrgRecord } from '@api/hr/bonus';
import TableExpenses from './TableExpenses';

class Manage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSource: {
        list: [],
        pagination: {},
        loading: false,
      },
    };
  }

  componentWillMount() {
    this.type = '0';
  }

  componentDidMount() {
    this.searchCondition = {};
    const { backInfo } = this.props;
    if (backInfo.path === this.props.location.pathname) {
      if (backInfo.start && backInfo.limit) {
        this.current = backInfo.start;
        this.pagination = {
          limit: backInfo.limit,
          start: backInfo.start,
        };
      }
      backInfo.condition && (this.searchCondition.condition = backInfo.condition);
      backInfo.createUser && (this.searchCondition.createUser = backInfo.createUser);
      backInfo.instanceStatus && (this.searchCondition.instanceStatus = backInfo.instanceStatus);
      backInfo.beginDate && (this.searchCondition.beginDate = backInfo.beginDate);
      backInfo.endDate && (this.searchCondition.endDate = backInfo.endDate);
    }
    this.loadData();
  }

  componentWillUnmount() {
    const params = {
      path: this.props.location.pathname,
      ...this.searchCondition,
      ...this.pagination,
    };
    this.props.dispatch(setBackInfo(params));
  }

  setTableData = res => {
    this.setState({
      dataSource: {
        list: res.data,
        pagination: {
          total: res.totalSize,
          pageSize: 15,
          current: this.current,
        },
      },
    });
  };

  handleTableChange = (pagination, filters, sorter) => {
    this.pagination = {
      limit: pagination.pageSize,
      start: pagination.current,
    };
    this.current = pagination.current;
    this.loadData();
  };

  handleSearch = params => {
    this.searchCondition = {
      ...params,
    };
    this.current = 1;
    this.pagination = {
      start: 1,
    };
    this.loadData();
  };

  handleChange = val => {
    this.type = val;
    this.current = 1;
    this.pagination = {
      start: 1,
    };
    this.loadData();
  };

  getBonusList = params => {
    this.setState({ loading: true });
    bonus(params).then(res => {
      if (res.statusCode === 200) {
        this.setTableData(res);
      }
      this.setState({ loading: false });
    });
  };

  getBonusOrgRecord = params => {
    queryBonusOrgRecord(params).then(res => {
      if (res.statusCode === 200) {
        this.setTableData(res);
      }
    });
  };

  loadData = () => {
    const params = {
      ...this.searchCondition,
      ...this.pagination,
    };
    this.getBonusList(params);
  };

  render() {
    const { loading, dataSource } = this.state;
    const parentProps = {
      loading,
      dataSource,
      onChange: this.handleTableChange,
    };
    return (
      <div>
        <Row>
          <Col span={24}>
            <FlowSearch onSearch={this.handleSearch} {...this.searchCondition} />
          </Col>
        </Row>
        <div id="ant-small-table">
          <TableExpenses {...parentProps} />
        </div>
      </div>
    );
  }
}
export default connect(state => ({
  backInfo: state.back_info,
}))(Manage);



// WEBPACK FOOTER //
// ./src/components/hr/bonus/PageWatch.js